var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25347 12.8699C11.0926 12.8699 12.8686 12.3498 13.0401 10.2623C13.0401 8.17614 11.8019 8.31029 11.8019 5.75069C11.8019 3.75136 10.0074 1.47656 7.25347 1.47656C4.49954 1.47656 2.70504 3.75136 2.70504 5.75069C2.70504 8.31029 1.4668 8.17614 1.4668 10.2623C1.639 12.3577 3.41505 12.8699 7.25347 12.8699Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87942 15.0332C7.95074 16.1222 6.50202 16.1351 5.56445 15.0332",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBell);
export default __webpack_public_path__ + "static/media/lightBell.f041b9e3b0b1706c0a330552cee47300.svg";
export { ForwardRef as ReactComponent };